// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-modal-privacy-policy-agreement a[data-v-539f9190]{text-decoration:underline}.c-modal-privacy-policy-agreement[data-v-539f9190] .m-form-checkbox{display:inline-block}", ""]);
// Exports
module.exports = exports;
